import React from 'react';
import { withStyles } from '@mui/styles';

const styles = {
  switcher: {
    width: '15px',
    height: '8px',
    display: 'flex',
    padding: '0 1px',
    borderRadius: '10px',
    alignItems: 'center',
    background: '#C4C4C4',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  switcherOn: {
    background: '#4B4F73',
  },
  thumb: {
    width: '6px',
    height: '6px',
    transition: '0.1s',
    background: '#fff',
    borderRadius: '50%',
  },
  thumbOn: {
    transition: '0.1s',
    transform: 'translateX(9px)',
  },
};

export default withStyles(styles)(({ classes, switched, readOnly, onChange }) => {
  const switcherClassName = `${classes.switcher} ${switched ? classes.switcherOn : ''}`;
  const thumbClassName = `${classes.thumb} ${switched ? classes.thumbOn : ''}`;

  return (
    <div
      onClick={() => {
        if (onChange) onChange(!switched);
      }}
      className={switcherClassName}
      style={{ pointerEvents: readOnly ? 'none' : '' }}
    >
      <div className={thumbClassName}></div>
    </div>
  );
});
